var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",style:({ width: _vm.xSize.width, height: _vm.xSize.height }),attrs:{"role":"img","viewBox":_vm.viewBox || '0 0 48 48',"fill":_vm.color || 'currentColor'}},[_vm._t("default",null,{"filled":_vm.filled})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }